/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SkeletonStyles from './SkeletonStyles';

const FILTER_SECTIONS = [0, 3, 2];

const styles = () => ({
    ...SkeletonStyles,
    root: {
        width: '100%',
        boxSizing: 'border-box',
        margin: '20px 0px',
    },
    section: {
        width: '100%',
        paddingBottom: '24px',
        marginBottom: '24px',
        borderBottom: '1px solid #D9D9D9',
        '&:last-child': {
            marginBottom: 0,
            borderBottom: 'none',
        },
    },
    rootTitleSkeleton: {
        width: '100%',
        height: '20px',
        borderRadius: '4px',
        minWidth: 0,
    },
    titleSkeleton: {
        width: '100%',
        height: '16px',
        borderRadius: '4px',
        minWidth: 0,
        marginBottom: '16px',
    },
    optionsList: {
        width: '100%',
        boxSizing: 'border-box',
    },
    skeletonOptionsList: {
        paddingLeft: '10px',
    },
    skeletonRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        minHeight: '40px',
        width: '100%',
    },
    squareControl: {
        width: '20px',
        height: '20px',
        borderRadius: '4px',
        flexShrink: 0,
    },
    line: {
        flex: 1,
        height: '14px',
        borderRadius: '4px',
        minWidth: 0,
    },
});

const ProductFacetSkeleton = ({ classes }) => (
    <div className={classes.root}>
        {FILTER_SECTIONS.map((rowCount) => (
            <div key={rowCount} className={classes.section}>
                <div className={`${rowCount === 0 ? classes.rootTitleSkeleton : classes.titleSkeleton} ${classes.shimmer}`} />
                <div className={`${classes.optionsList} ${classes.skeletonOptionsList}`}>
                    {Array.from({ length: rowCount }).map((_, index) => (
                        <div key={`${rowCount}-${index + 1}`} className={classes.skeletonRow}>
                            <div className={`${classes.squareControl} ${classes.shimmer}`} />
                            <div className={`${classes.line} ${classes.shimmer}`} />
                        </div>
                    ))}
                </div>
            </div>
        ))}
    </div>
);

ProductFacetSkeleton.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(ProductFacetSkeleton);
